import React, { useState, useEffect } from "react";
import Footer from "components/footer/Footer";
import SectionThree from "components/sectionThree/SectionThree";
import { useParams, useNavigate } from "react-router-dom";
import HalfArrow from "assets/images/half-arrow.svg";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "redux-store/store";
import {
  errorCleanUp,
  verifyEmail,
  messageCleanUp,
} from "redux-store/auth/auth.slice";
import { error, loginSuccessMessage } from "redux-store/auth/auth.selector";
import OtpInput from "react-otp-input";

const EnterOTP = () => {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const succesMessage = useSelector(loginSuccessMessage);
  const signUpError = useSelector(error);
  const [otp, setOtp] = useState("");

  useEffect(() => {
    dispatch(errorCleanUp());
    dispatch(messageCleanUp());
    if (succesMessage !== "") {
      if (params.path === "signup") {
        navigate(`/`);
      } else {
        let code = otp;
        navigate(`/auth/new-password/${code}/${params.email}`);
      }
    }
  }, [succesMessage]);

  const handleOpt = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();

    const otpCode = {
      email: params.email,
      code: otp,
    };
    dispatch(errorCleanUp());
    if (succesMessage !== "") {
      dispatch(messageCleanUp());
    }
    dispatch(verifyEmail(otpCode));
  };

  return (
    <div className="tw-w-full">
      {/* 1st main div */}
      <div className="tw-w-full">
        <SectionThree>
          <div className="lg:tw-w-fit tw-w-[80%] tw-mx-auto tw-px-12 tw-bg-white tw-py-6 tw-shadow-small tw-rounded-[1.9375rem] lg:tw-rounded-[1.25rem] lg:tw-shadow-large">
            <div className="tw-flex tw-flex-col tw-space-y-3 tw-py-4 ">
              <div className="tw-flex tw-items-center tw-justify-center lg:tw-justify-start  ">
                <span className="tw-text-[1.625rem] tw-text-black tw-font-bold lg:tw-text-[2.25rem]">
                  Enter OTP
                </span>
              </div>
              <div>
                <form>
                  <div className="tw-flex tw-flex-col tw-space-y-3 tw-items-center lg:tw-items-start">
                    <div>
                      <label className="tw-text-black tw-text-[0.75rem] tw-font-normal lg:text-[1.76rem] tw-text-center">
                        A 6-digit code has been sent to your email
                      </label>
                    </div>
                    <div className="tw-w-full tw-flex tw-flex-row tw-space-x-1 lg:tw-place-content-start md:tw-place-content-center sm:tw-place-content-center tw-justify-center">
                      <OtpInput
                        value={otp}
                        onChange={setOtp}
                        numInputs={6}
                        // renderSeparator={<span>-</span>}
                        renderInput={(props, index) => (
                          <input
                            {...props}
                            className="tw-text-center tw-rounded-[0.3125rem] lg:tw-text-[3.925rem] md:tw-text-[2.925rem] tw-text-[1.95rem] tw-text-reddishOrange tw-bg-[#ffddd2] focus:tw-outline-none focus:tw-bg-reddishOrange focus:tw-text-white tw-flex tw-mx-4"
                            key={index}
                            type="number"
                            inputMode="numeric"
                          />
                        )}
                        inputStyle={{
                          marginRight: "6px",
                          justifyContent: "center",
                        }}
                      />
                    </div>
                    <div className="tw-text-[0.75rem] tw-font-normal lg:tw-text-[1rem]">
                      <span>You should receive the OTP</span>
                      <span className="tw-ml-1 tw-text-[#FF7B6D]">
                        in 30 Seconds
                      </span>
                    </div>

                    <div className="tw-flex tw-items-center tw-justify-center tw-flex-col tw-gap-2">
                      <span className="tw-text-xs tw-text-red-500">
                        {signUpError.message !== "" ? signUpError.message : ""}
                      </span>
                      <button
                        type="submit"
                        className="tw-flex tw-items-center tw-space-x-1.5 tw-py-1 tw-px-4 tw-rounded-full tw-bg-[#FF7B6D] tw-text-[0.875rem] tw-text-white lg:tw-text-[1rem]"
                        onClick={(e) => handleOpt(e)}
                      >
                        <span className="tw-uppercase">Verify</span>
                        <img src={HalfArrow} alt="arrow" />
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </SectionThree>
      </div>

      {/* 2nd main div */}
      <div className="tw-flex">
        <Footer />
      </div>
    </div>
  );
};

export default EnterOTP;
